import React from 'react'
import { Table, Modal, Avatar, Progress, Tag } from 'antd'
import { TableRowEditButton } from '../../components/AppButton'
import defaultPicture from '../../assets/default.png'

import moment from 'moment'
import 'moment/locale/ru'

class ItemListTable extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleDeleteButtonOnClick = this.handleDeleteButtonOnClick.bind(this)
  }

  handleDeleteButtonOnClick() {
    const handleTableOnDelete = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      onOk() {
        handleTableOnDelete()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'idnum',
        key: 'idnum',
        sorter: true,
      }, {
        title: 'Активность',
        dataIndex: 'n_enable',
        key: 'n_enable',
        render: (record, row) =>
          ((Number(record) === 1 && moment(row.d_end, 'YYYY-MM-DD').format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) ? (
            <Tag color='green'>Включена</Tag>
          ) : (
            <Tag color='red'>Выключена</Tag>
          )),
      }, {
        title: 'Лого',
        dataIndex: 's_logo',
        key: 's_logo',
        render: record => <Avatar src={record || defaultPicture} />,
      }, {
        title: 'Торговая сеть',
        dataIndex: 's_seller',
        key: 's_seller',
        sorter: true,
      }, {
        title: 'Название',
        dataIndex: 's_name',
        key: 's_name',
        sorter: true,
      }, {
        title: 'Период действия',
        dataIndex: 'd_begin',
        key: 'd_begin',
        colSpan: 2,
        sorter: true,
        onHeaderCell: () => ({
          style: {
            whiteSpace: 'nowrap',
          },
        }),
        onCell: () => ({
          style: {
            whiteSpace: 'nowrap',
          },
        }),
      }, {
        title: 'Период действия',
        dataIndex: 'd_end',
        key: 'd_end',
        colSpan: 0,
        onHeaderCell: () => ({
          style: {
            whiteSpace: 'nowrap',
          },
        }),
        onCell: () => ({
          style: {
            whiteSpace: 'nowrap',
          },
        }),
      }, {
        title: 'Действие',
        key: 'action',
        onHeaderCell: () => ({
          style: {
            whiteSpace: 'nowrap',
          },
        }),
        onCell: () => ({
          style: {
            whiteSpace: 'nowrap',
          },
        }),
        render: (row, record) => (
          <TableRowEditButton to={`${this.props.editPath}/${record.idnum}`} />
        ),
      },
    ]
    return (
      <Table
        rowKey={record => `item-row-${record.idnum}`}
        columns={columns}
        {...this.props}
      />
    )
  }
}

export default ItemListTable



// WEBPACK FOOTER //
// src/containers/ActionList/Table.jsx